import type { SvgIconProps } from '../../types/props.ts'

export const TikTokIcon = (props: SvgIconProps) => {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      aria-hidden={true}
      role="img"
      {...props}
    >
      <g filter="url(#filter0_d_18394_207315)">
        <path
          d="M2.54688 7.99252C2.54688 4.68294 5.44396 2 9.0177 2H43.5287C47.1025 2 49.9996 4.68294 49.9996 7.99252V44.0075C49.9996 47.3171 47.1025 50 43.5287 50H9.0177C5.44396 50 2.54688 47.3171 2.54688 44.0075V7.99252Z"
          fill="white"
        />
      </g>
      <g clipPath="url(#clip0_18394_207315)">
        <path
          d="M33.4397 21.4775C35.5397 22.9781 38.1126 23.8611 40.8914 23.8611V18.5165C40.3654 18.5165 39.8409 18.4616 39.3265 18.3529V22.5598C36.6545 22.5637 34.0483 21.7301 31.8746 20.1762V31.0829C31.8746 36.539 27.4491 40.9619 21.9907 40.9619C20.0311 40.9653 18.1151 40.3834 16.4883 39.2909C18.2831 41.1251 20.7862 42.263 23.5553 42.263C29.0142 42.263 33.4397 37.8404 33.4397 32.384V21.4775ZM35.3699 16.0857C34.2657 14.8829 33.5875 13.3505 33.4397 11.7245V11.0371H31.9566C32.3302 13.1653 33.6033 14.9835 35.3702 16.0857M19.941 35.104C19.3413 34.3183 19.0171 33.3569 19.0185 32.3685C19.0185 29.873 21.0428 27.8497 23.54 27.8497C24.0051 27.8497 24.4678 27.9209 24.9115 28.0614V22.5974C24.3932 22.5262 23.8702 22.4961 23.3472 22.5074V26.7603C22.9034 26.6196 22.4405 26.5482 21.9749 26.5487C19.4777 26.5487 17.4537 28.5717 17.4537 31.0674C17.4537 32.8322 18.4656 34.36 19.941 35.104Z"
          fill="#FF004F"
        />
        <path
          d="M31.8748 20.1762C34.0486 21.7301 36.6549 22.5638 39.327 22.5598V18.3524C37.8044 18.0269 36.4212 17.2344 35.3704 16.0854C33.6033 14.9835 32.3302 13.1653 31.9569 11.0371H28.0612V32.3837C28.0526 34.8723 26.0319 36.8874 23.5403 36.8874C22.0717 36.8874 20.7673 36.1878 19.9409 35.104C18.4658 34.36 17.4542 32.8322 17.4542 31.0676C17.4542 28.5722 19.4779 26.5487 21.9751 26.5487C22.4537 26.5487 22.9149 26.6231 23.3474 26.7603V22.5074C17.9847 22.6182 13.6719 26.9977 13.6719 32.384C13.6719 35.0725 14.7458 37.51 16.489 39.2909C18.1158 40.3832 20.0317 40.9651 21.9912 40.9619C27.4498 40.9619 31.875 36.539 31.875 31.0831V20.1764L31.8748 20.1762Z"
          fill="black"
        />
        <path
          d="M39.3274 18.3529V17.2155C37.9287 17.2176 36.5575 16.8261 35.3708 16.0857C36.4212 17.2353 37.8045 18.028 39.3274 18.3529ZM31.9573 11.0374C31.9217 10.8341 31.8944 10.6295 31.8754 10.4237V9.73633H26.4968V31.0832C26.4882 33.5715 24.4677 35.5866 21.9755 35.5866C21.2439 35.5866 20.5533 35.4131 19.9413 35.1046C20.7677 36.1881 22.0721 36.8877 23.5407 36.8877C26.0323 36.8877 28.053 34.8726 28.0619 32.3843V11.0374H31.9573ZM23.3478 22.5077V21.2969C22.8984 21.2352 22.4454 21.2045 21.9918 21.2049C16.5326 21.2046 12.1074 25.6275 12.1074 31.0832C12.1074 34.5036 13.8466 37.5179 16.4894 39.2912C14.7462 37.5103 13.6723 35.0728 13.6723 32.3843C13.6723 26.998 17.9849 22.6185 23.3478 22.5077Z"
          fill="#00F2EA"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_18394_207315"
          x="0.546875"
          y="0"
          width="55.4531"
          height="56"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2" dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18394_207315"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18394_207315"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_18394_207315">
          <rect
            width="32.527"
            height="32.527"
            fill="white"
            transform="translate(10.0742 9.73633)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
